import tw from 'tailwind-styled-components'

export const UploadModalWrapper = tw.div`flex flex-col items-center gap-4  text-primary`

export const UploadFileWrapper = tw.div`border py-4 gap-4 flex flex-col px-5 items-center text-primary`

export const UploadFileInfo = tw.div`flex flex-col items-center`
